// extracted by mini-css-extract-plugin
export default {"videoBlock":"VideoBlock_videoBlock__W+H+u","video":"VideoBlock_video__XQFME"};